import { getToken } from "containers/Auth";
import { handleLogout } from "routes/Login/module";
import { INACTIVITY_MSG } from "constants/constants";
import { METHOD } from "../../constants/constants"

export const getApiBaseUrl = () => {
  let urls = {
    GO: {
      US: process.env.REACT_APP_API_GO_US_URL,
      EU: process.env.REACT_APP_API_GO_EU_URL
    },
    RAILS: {
      US: process.env.REACT_APP_API_RAILS_US_URL,
      EU: process.env.REACT_APP_API_RAILS_EU_URL,
    }
  };
  // if(process.env.API_GO_US_URL) urls.GO.US = process.env.API_GO_US_URL;
  // if(process.env.API_GO_EU_URL) urls.GO.EU = process.env.API_GO_EU_URL;
  // if(process.env.API_RAILS_US_URL) urls.RAILS.US = process.env.API_RAILS_US_URL;
  // if(process.env.API_RAILS_EU_URL) urls.RAILS.EU = process.env.API_RAILS_EU_URL;
  
  // if (process.env.__DEV__) {
  //   return {
  //     GO: {
  //       US: "https://us-kardia-staging.alivecor.com",
  //       EU: "https://eu-kardia-staging.alivecor.com"
  //     },
  //     RAILS: {
  //       US: "https://us-alivecor-staging.alivecor.com",
  //       EU: "https://eu-alivecor-staging.alivecor.com",
  //     }
  //   };
  // }
  // if (process.env.__K8SDEV__) {
  //   return {
  //     GO: {
  //       US: "https://us-kardia-k8s.development.alivecor.net",
  //       EU: "https://eu-kardia-k8s.development.alivecor.net"
  //     },
  //     RAILS: {
  //       US: "https://us-alivecor-k8s.development.alivecor.net",
  //       EU: "https://eu-alivecor-k8s.development.alivecor.net",
  //     }
  //   };
  // }
  // if (process.env.__STAGING__) {
  //   return {
  //     GO: {
  //       US: "https://us-kardia-staging.alivecor.com",
  //       EU: "https://eu-kardia-staging.alivecor.com"
  //     },
  //     RAILS: {
  //       US: "https://us-alivecor-staging.alivecor.com",
  //       EU: "https://eu-alivecor-staging.alivecor.com",
  //     }
  //   };
  // }
  // if (process.env.__PROD__) {
  //   return {
  //     GO: {
  //       US: "https://us-kardia-production.alivecor.com",
  //       EU: "https://eu-kardia-production.alivecor.com"
  //     },
  //     RAILS: {
  //       US: "https://us-alivecor-production.alivecor.com",
  //       EU: "https://eu-alivecor-production.alivecor.com",
  //     }
  //   };
  // }
  return urls;
};

export const fetchApi = (url = "", withAuth = false, method = METHOD.GET, extra = {
  data: {},
  headers: {},
}) => {
  return (dispatch, getState) => {
    const headers = new Headers({
      "Content-Type": "application/json",
      Accept: "application/json",
      ...extra.headers,
    });

    !!withAuth && headers.append("Authorization", `Bearer ${getToken() || ""}`);

    const init = {
      method,
      headers: headers,
      mode: "cors",
    };

    if (method === METHOD.POST || method === METHOD.DELETE) {
      init.body = JSON.stringify(extra.data)
    }

    return fetch(url, init) // #CheckPoint
      .then(res => {
        if (res.status === 401) {
          dispatch(handleLogout(null, INACTIVITY_MSG));
          return;
        }
        return res;
      })
      .catch(err => {
        console.log(err);
      });
  };
};

export const FETCH_STATUS = Object.freeze({
  NOT_LOADED: "NOT LOADED",
  LOADING: "LOADING",
  LOADED: "LOADED",
  ERRORED: "ERRORED"
});


// WEBPACK FOOTER //
// ./src/containers/ApiUrls/index.js